/*
    ----------------------------
        APPS CONTENT TABLE
    ----------------------------

    <!-- ======== GLOBAL SCRIPT SETTING ======== -->
    01. Global Variable
    02. Handle Scrollbar
    03. Handle Sidebar Menu
    04. Handle Sidebar Scroll Memory
    05. Handle Card Action
    06. Handle Tooltip & Popover Activation
    07. Handle Scroll to Top Button
    08. Handle hexToRgba
    09. Handle Scroll To
    10. Handle Toggle Class
    11. Handle Theme Panel
    12. Application Controller
    13. Initialise
	
    <!-- ======== APPLICATION SETTING ======== -->
    Application Controller
*/

/**
 * Setup Header stuff.
 */
(function installJQueryLegacyCompat(global) {
    var jq = global.jQuery || global.$;

    if (!jq) {
        return;
    }

    if (typeof jq.isArray !== "function") {
        jq.isArray = Array.isArray;
    }

    if (typeof jq.isFunction !== "function") {
        jq.isFunction = function (value) {
            return typeof value === "function";
        };
    }

    if (typeof jq.trim !== "function") {
        jq.trim = function (value) {
            return value == null ? "" : String(value).trim();
        };
    }

    if (typeof jq.parseJSON !== "function") {
        jq.parseJSON = function (value) {
            return JSON.parse(String(value));
        };
    }

    if (typeof jq.now !== "function") {
        jq.now = Date.now;
    }

    if (typeof jq.proxy !== "function") {
        jq.proxy = function (fn, context) {
            var args = Array.prototype.slice.call(arguments, 2);
            var proxyFn;

            if (typeof context === "string") {
                if (!fn || typeof fn[context] !== "function") {
                    return undefined;
                }

                proxyFn = function () {
                    return fn[context].apply(fn, args.concat(Array.prototype.slice.call(arguments)));
                };
            } else {
                if (typeof fn !== "function") {
                    return undefined;
                }

                proxyFn = function () {
                    return fn.apply(context || this, args.concat(Array.prototype.slice.call(arguments)));
                };
            }

            if (typeof jq.guid === "number") {
                proxyFn.guid = fn.guid = fn.guid || jq.guid++;
            }

            return proxyFn;
        };
    }

    if (typeof jq.type !== "function") {
        jq.type = function (value) {
            if (value == null) {
                return String(value);
            }

            if (Array.isArray(value)) {
                return "array";
            }

            if (value instanceof Date) {
                return "date";
            }

            if (value instanceof RegExp) {
                return "regexp";
            }

            return typeof value === "object"
                ? Object.prototype.toString.call(value).slice(8, -1).toLowerCase()
                : typeof value;
        };
    }
})(window);

(function installSelectPickerStackingSupport(global) {
    var jq = global.jQuery || global.$;

    if (!jq) {
        return;
    }

    jq(document)
        .off('.pickerStacking')
        .on('sp-open.pickerStacking', 'select', function () {
            var $card = jq(this).closest('.card');

            jq('.card.picker-open').not($card).removeClass('picker-open');

            if ($card.length) {
                $card.addClass('picker-open');
            }
        })
        .on('sp-close.pickerStacking', 'select', function () {
            jq(this).closest('.card').removeClass('picker-open');
        });
})(window);

document.addEventListener("DOMContentLoaded", function () {
    const avatarImg = document.getElementById("avatar-img");
    const userName = document.getElementById("user-name");

    const userAvatar = Cookies.get("avatar");
    const displayName = Cookies.get("name");

    if (avatarImg) {
        if (userAvatar) {
            avatarImg.src = userAvatar;
        } else {
            avatarImg.src = "https://proxy.duckduckgo.com/iu/?u=https://i.imgur.com/0r65LVT.jpg";
        }
    }
    if (userName) {
        userName.textContent = displayName || "Guest";
    }
});

/* 01. Global Variable
------------------------------------------------ */
var app = {
    id: "#app",
    isMobile:
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        ),
    bootstrap: {
        tooltip: {
            attr: 'data-bs-toggle="tooltip"',
        },
        popover: {
            attr: 'data-bs-toggle="popover"',
        },
        modal: {
            attr: 'data-bs-toggle="modal"',
            dismissAttr: 'data-bs-dismiss="modal"',
            event: {
                hidden: "hidden.bs.modal",
            },
        },
        nav: {
            class: "nav",
            tabs: {
                class: "nav-tabs",
                activeClass: "active",
                itemClass: "nav-item",
                itemLinkClass: "nav-link",
            },
        },
    },
    header: {
        id: "#header",
        class: "app-header",
        hasScrollClass: "has-scroll",
    },
    sidebar: {
        id: "#sidebar",
        class: "app-sidebar",
        scrollBar: {
            localStorage: "appSidebarScrollPosition",
            dom: "",
        },
        menu: {
            class: "menu",
            initAttr: "data-init",
            animationTime: 0,
            itemClass: "menu-item",
            itemLinkClass: "menu-link",
            hasSubClass: "has-sub",
            activeClass: "active",
            expandingClass: "expanding",
            expandClass: "expand",
            submenu: {
                class: "menu-submenu",
            },
        },
        mobile: {
            toggleAttr: 'data-toggle="app-sidebar-mobile"',
            dismissAttr: 'data-dismiss="app-sidebar-mobile"',
            toggledClass: "app-sidebar-mobile-toggled",
            closedClass: "app-sidebar-mobile-closed",
            backdrop: {
                class: "app-sidebar-mobile-backdrop",
            },
        },
        minify: {
            toggleAttr: 'data-toggle="app-sidebar-minify"',
            toggledClass: "app-sidebar-minified",
            cookieName: "app-sidebar-minified",
        },
        floatSubmenu: {
            id: "#app-sidebar-float-submenu",
            dom: "",
            timeout: "",
            class: "app-sidebar-float-submenu",
            container: {
                class: "app-sidebar-float-submenu-container",
            },
            arrow: {
                id: "#app-sidebar-float-submenu-arrow",
                class: "app-sidebar-float-submenu-arrow",
            },
            line: {
                id: "#app-sidebar-float-submenu-line",
                class: "app-sidebar-float-submenu-line",
            },
            overflow: {
                class: "overflow-scroll mh-100vh",
            },
        },
        search: {
            class: "menu-search",
            toggleAttr: 'data-sidebar-search="true"',
            hideClass: "d-none",
            foundClass: "has-text",
        },
        transparent: {
            class: "app-sidebar-transparent",
        },
    },
    scrollBar: {
        attr: 'data-scrollbar="true"',
        skipMobileAttr: "data-skip-mobile",
        heightAttr: "data-height",
        wheelPropagationAttr: "data-wheel-propagation",
    },
    content: {
        id: "#content",
        class: "app-content",
        fullHeight: {
            class: "app-content-full-height",
        },
        fullWidth: {
            class: "app-content-full-width",
        },
    },
    layout: {
        sidebarLight: {
            class: "app-with-light-sidebar",
        },
        sidebarEnd: {
            class: "app-with-end-sidebar",
        },
        sidebarWide: {
            class: "app-with-wide-sidebar",
        },
        sidebarMinified: {
            class: "app-sidebar-minified",
        },
        sidebarTwo: {
            class: "app-with-two-sidebar",
        },
        withoutHeader: {
            class: "app-without-header",
        },
        withoutSidebar: {
            class: "app-without-sidebar",
        },
        topMenu: {
            class: "app-with-top-menu",
        },
        boxedLayout: {
            class: "boxed-layout",
        },
    },
    scrollToTopBtn: {
        showClass: "show",
        heightShow: 200,
        toggleAttr: 'data-toggle="scroll-to-top"',
        scrollSpeed: 500,
    },
    scrollTo: {
        attr: 'data-toggle="scroll-to"',
        target: "data-target",
        linkTarget: "href",
    },
    themePanel: {
        class: "app-theme-panel",
        toggleAttr: 'data-toggle="theme-panel-expand"',
        cookieName: "app-theme-panel-expand",
        activeClass: "active",
        themeListCLass: "app-theme-list",
        themeListItemCLass: "app-theme-list-item",
        themeCoverClass: "app-theme-cover",
        themeCoverItemClass: "app-theme-cover-item",
        theme: {
            toggleAttr: 'data-toggle="theme-selector"',
            classAttr: "data-theme-class",
            cookieName: "app-theme",
            activeClass: "active",
        },
        themeCover: {
            toggleAttr: 'data-toggle="theme-cover-selector"',
            classAttr: "data-theme-cover-class",
            cookieName: "app-theme-cover",
            activeClass: "active",
        },
    },
    dismissClass: {
        toggleAttr: "data-dismiss-class",
        targetAttr: "data-dismiss-target",
    },
    toggleClass: {
        toggleAttr: "data-toggle-class",
        targetAttr: "data-toggle-target",
    },
    font: {
        family: getComputedStyle(document.body)
            .getPropertyValue("--bs-body-font-family")
            .trim(),
        size: getComputedStyle(document.body)
            .getPropertyValue("--bs-body-font-size")
            .trim(),
        weight: getComputedStyle(document.body)
            .getPropertyValue("--bs-body-font-weight")
            .trim(),
    },
    color: {
        theme: getComputedStyle(document.body)
            .getPropertyValue("--bs-theme")
            .trim(),
        blue: getComputedStyle(document.body).getPropertyValue("--bs-blue").trim(),
        green: getComputedStyle(document.body)
            .getPropertyValue("--bs-green")
            .trim(),
        orange: getComputedStyle(document.body)
            .getPropertyValue("--bs-orange")
            .trim(),
        red: getComputedStyle(document.body).getPropertyValue("--bs-red").trim(),
        cyan: getComputedStyle(document.body).getPropertyValue("--bs-cyan").trim(),
        purple: getComputedStyle(document.body)
            .getPropertyValue("--bs-purple")
            .trim(),
        yellow: getComputedStyle(document.body)
            .getPropertyValue("--bs-yellow")
            .trim(),
        indigo: getComputedStyle(document.body)
            .getPropertyValue("--bs-indigo")
            .trim(),
        pink: getComputedStyle(document.body).getPropertyValue("--bs-pink").trim(),
        black: getComputedStyle(document.body)
            .getPropertyValue("--bs-black")
            .trim(),
        white: getComputedStyle(document.body)
            .getPropertyValue("--bs-white")
            .trim(),
        gray: getComputedStyle(document.body).getPropertyValue("--bs-gray").trim(),
        dark: getComputedStyle(document.body).getPropertyValue("--bs-dark").trim(),
        gray100: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-100")
            .trim(),
        gray200: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-200")
            .trim(),
        gray300: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-300")
            .trim(),
        gray400: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-400")
            .trim(),
        gray500: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-500")
            .trim(),
        gray600: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-600")
            .trim(),
        gray700: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-700")
            .trim(),
        gray800: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-800")
            .trim(),
        gray900: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-900")
            .trim(),

        themeRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-theme-rgb")
            .trim(),
        blueRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-blue-rgb")
            .trim(),
        greenRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-green-rgb")
            .trim(),
        orangeRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-orange-rgb")
            .trim(),
        redRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-red-rgb")
            .trim(),
        cyanRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-cyan-rgb")
            .trim(),
        purpleRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-purple-rgb")
            .trim(),
        yellowRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-yellow-rgb")
            .trim(),
        indigoRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-indigo-rgb")
            .trim(),
        pinkRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-pink-rgb")
            .trim(),
        blackRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-black-rgb")
            .trim(),
        whiteRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-white-rgb")
            .trim(),
        grayRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-rgb")
            .trim(),
        darkRgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-dark-rgb")
            .trim(),
        gray100Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-100-rgb")
            .trim(),
        gray200Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-200-rgb")
            .trim(),
        gray300Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-300-rgb")
            .trim(),
        gray400Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-400-rgb")
            .trim(),
        gray500Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-500-rgb")
            .trim(),
        gray600Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-600-rgb")
            .trim(),
        gray700Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-700-rgb")
            .trim(),
        gray800Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-800-rgb")
            .trim(),
        gray900Rgb: getComputedStyle(document.body)
            .getPropertyValue("--bs-gray-900-rgb")
            .trim(),
    },
    card: {
        expand: {
            status: false,
            toggleAttr: 'data-toggle="card-expand"',
            toggleTitle: "Expand / Compress",
            class: "card-expand",
        },
    },
    init: {
        attr: "data-init",
        class: "app-init",
    },
};

/* 02. Handle Scrollbar
------------------------------------------------ */
var handleScrollbar = function () {
    "use strict";
    var elms = document.querySelectorAll("[" + app.scrollBar.attr + "]");

    for (var i = 0; i < elms.length; i++) {
        generateScrollbar(elms[i]);
    }
};

var refreshScrollbars = function () {
    "use strict";
    var elms = document.querySelectorAll("[" + app.scrollBar.attr + "]");

    for (var i = 0; i < elms.length; i++) {
        var elm = elms[i];

        if (!elm.scrollbarInit) {
            generateScrollbar(elm);
            continue;
        }

        if (elm.perfectScrollbar && typeof elm.perfectScrollbar.update === "function") {
            elm.perfectScrollbar.update();
        }
    }
};

var syncResponsiveDataTableScrollbars = function () {
    "use strict";

    var wrappers = document.querySelectorAll(".datatable, .table-responsive");

    for (var i = 0; i < wrappers.length; i++) {
        var wrapper = wrappers[i];

        if (!isElementVisible(wrapper)) {
            continue;
        }

        if (
            wrapper.closest(".bootstrap-table") ||
            wrapper.classList.contains("fixed-table-body")
        ) {
            continue;
        }

        var containsManagedDataTable =
            wrapper.classList.contains("datatable") ||
            !!wrapper.querySelector("table.dataTable, table[id^='datatable']");

        if (!containsManagedDataTable) {
            continue;
        }

        var measuredHeight = Math.round(wrapper.getBoundingClientRect().height);
        if (!measuredHeight || measuredHeight <= 0) {
            continue;
        }

        wrapper.setAttribute("data-scrollbar", "true");
        wrapper.setAttribute(app.scrollBar.heightAttr, measuredHeight + "px");

        if (!wrapper.scrollbarInit) {
            generateScrollbar(wrapper);
            continue;
        }

        if (wrapper.perfectScrollbar && typeof wrapper.perfectScrollbar.update === "function") {
            wrapper.perfectScrollbar.update();
        }
    }
};

var queueResponsiveDataTableScrollbarSync = function () {
    "use strict";

    if (queueResponsiveDataTableScrollbarSync._frame) {
        window.cancelAnimationFrame(queueResponsiveDataTableScrollbarSync._frame);
    }

    queueResponsiveDataTableScrollbarSync._frame = window.requestAnimationFrame(function () {
        syncResponsiveDataTableScrollbars();
    });
};

var observeDynamicScrollbars = function () {
    "use strict";

    if (
        window.__cockpitScrollbarObserverInit ||
        typeof MutationObserver === "undefined" ||
        !document.body
    ) {
        return;
    }

    window.__cockpitScrollbarObserverInit = true;

    var selector = "[" + app.scrollBar.attr + "]";
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            [].slice.call(mutation.addedNodes || []).forEach(function (node) {
                if (!node || node.nodeType !== 1) {
                    return;
                }

                if (node.matches && node.matches(selector)) {
                    generateScrollbar(node);
                }

                if (node.querySelectorAll) {
                    [].slice
                        .call(node.querySelectorAll(selector))
                        .forEach(generateScrollbar);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};
var generateScrollbar = function (elm) {
    "use strict";

    if (
        elm.scrollbarInit ||
        (app.isMobile && elm.getAttribute(app.scrollBar.skipMobileAttr))
    ) {
        return;
    }
    var dataHeight = !elm.getAttribute(app.scrollBar.heightAttr)
        ? elm.offsetHeight
        : elm.getAttribute(app.scrollBar.heightAttr);

    var parsedHeight = parseInt(dataHeight, 10);
    if (!dataHeight || Number.isNaN(parsedHeight) || parsedHeight <= 0) {
        return;
    }

    elm.style.height = dataHeight;
    elm.scrollbarInit = true;

    if (app.isMobile) {
        elm.style.overflowX = "scroll";
    } else {
        var dataWheelPropagation = elm.getAttribute(
            app.scrollBar.wheelPropagationAttr
        )
            ? elm.getAttribute(app.scrollBar.wheelPropagationAttr)
            : false;

        if (
            elm.closest("." + app.sidebar.class) &&
            elm.closest("." + app.sidebar.class).length !== 0
        ) {
            app.sidebar.scrollBar.dom = new PerfectScrollbar(elm, {
                wheelPropagation: dataWheelPropagation,
            });
            elm.perfectScrollbar = app.sidebar.scrollBar.dom;
        } else {
            elm.perfectScrollbar = new PerfectScrollbar(elm, {
                wheelPropagation: dataWheelPropagation,
            });
        }
    }
    elm.setAttribute(app.init.attr, true);
    elm.classList.remove("invisible");
};

var teardownScrollbar = function (elm) {
    "use strict";

    if (!elm) {
        return;
    }

    try {
        if (elm.perfectScrollbar && typeof elm.perfectScrollbar.destroy === "function") {
            elm.perfectScrollbar.destroy();
        }
    } catch (error) {
        // Ignore teardown races while DOM refresh is in progress.
    }

    elm.perfectScrollbar = null;
    elm.scrollbarInit = false;
    elm.classList.remove("ps");
};

/* 03. Handle Sidebar Menu
------------------------------------------------ */
var handleSidebarMenuToggle = function (menus) {
    menus.map(function (menu) {
        menu.onclick = function (e) {
            e.preventDefault();
            var target = this.nextElementSibling;

            menus.map(function (m) {
                var otherTarget = m.nextElementSibling;
                if (otherTarget !== target) {
                    otherTarget.style.display = "none";
                    otherTarget
                        .closest("." + app.sidebar.menu.itemClass)
                        .classList.remove(app.sidebar.menu.expandClass);
                }
            });

            var targetItemElm = target.closest("." + app.sidebar.menu.itemClass);

            if (
                targetItemElm.classList.contains(app.sidebar.menu.expandClass) ||
                (targetItemElm.classList.contains(app.sidebar.menu.activeClass) &&
                    !target.style.display)
            ) {
                targetItemElm.classList.remove(app.sidebar.menu.expandClass);
                target.style.display = "none";
            } else {
                targetItemElm.classList.add(app.sidebar.menu.expandClass);
                target.style.display = "block";
            }
        };
    });
};
var handleSidebarMenu = function () {
    "use strict";

    var menuBaseSelector =
        "." +
        app.sidebar.class +
        " ." +
        app.sidebar.menu.class +
        " > ." +
        app.sidebar.menu.itemClass +
        "." +
        app.sidebar.menu.hasSubClass;
    var submenuBaseSelector =
        " > ." +
        app.sidebar.menu.submenu.class +
        " > ." +
        app.sidebar.menu.itemClass +
        "." +
        app.sidebar.menu.hasSubClass;

    // menu
    var menuLinkSelector =
        menuBaseSelector + " > ." + app.sidebar.menu.itemLinkClass;
    var menus = [].slice.call(document.querySelectorAll(menuLinkSelector));
    handleSidebarMenuToggle(menus);

    // submenu lvl 1
    var submenuLvl1Selector = menuBaseSelector + submenuBaseSelector;
    var submenusLvl1 = [].slice.call(
        document.querySelectorAll(
            submenuLvl1Selector + " > ." + app.sidebar.menu.itemLinkClass
        )
    );
    handleSidebarMenuToggle(submenusLvl1);

    // submenu lvl 2
    var submenuLvl2Selector =
        menuBaseSelector + submenuBaseSelector + submenuBaseSelector;
    var submenusLvl2 = [].slice.call(
        document.querySelectorAll(
            submenuLvl2Selector + " > ." + app.sidebar.menu.itemLinkClass
        )
    );
    handleSidebarMenuToggle(submenusLvl2);
};

/* 04. Handle Sidebar Scroll Memory
------------------------------------------------ */
var handleSidebarScrollMemory = function () {
    if (!app.isMobile) {
        try {
            if (
                typeof Storage !== "undefined" &&
                typeof localStorage !== "undefined"
            ) {
                var elm = document.querySelector(
                    "." + app.sidebar.class + " [" + app.scrollBar.attr + "]"
                );

                if (elm) {
                    elm.onscroll = function () {
                        localStorage.setItem(
                            app.sidebar.scrollBar.localStorage,
                            this.scrollTop
                        );
                    };
                    var defaultScroll = localStorage.getItem(
                        app.sidebar.scrollBar.localStorage
                    );
                    if (defaultScroll) {
                        document.querySelector(
                            "." + app.sidebar.class + " [" + app.scrollBar.attr + "]"
                        ).scrollTop = defaultScroll;
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
};

/* 05. Handle Card Action
------------------------------------------------ */
var handleCardAction = function () {
    "use strict";

    if (app.card.expand.status) {
        return false;
    }
    app.card.expand.status = true;

    // expand
    var expandTogglerList = [].slice.call(
        document.querySelectorAll("[" + app.card.expand.toggleAttr + "]")
    );
    var expandTogglerTooltipList = expandTogglerList.map(
        function (expandTogglerEl) {
            expandTogglerEl.onclick = function (e) {
                e.preventDefault();

                var target = this.closest(".card");
                var targetClass = app.card.expand.class;
                var targetTop = 40;

                if (
                    document.body.classList.contains(targetClass) &&
                    target.classList.contains(targetClass)
                ) {
                    target.removeAttribute("style");
                    target.classList.remove(targetClass);
                    document.body.classList.remove(targetClass);
                } else {
                    document.body.classList.add(targetClass);
                    target.classList.add(targetClass);
                }

                window.dispatchEvent(new Event("resize"));
            };

            return new bootstrap.Tooltip(expandTogglerEl, {
                title: app.card.expand.toggleTitle,
                placement: "bottom",
                trigger: "hover",
                container: "body",
            });
        }
    );
};

/* 06. Handle Tooltip & Popover Activation
------------------------------------------------ */
var handelTooltipPopoverActivation = function () {
    "use strict";

    var tooltipTriggerList = [].slice.call(
        document.querySelectorAll("[" + app.bootstrap.tooltip.attr + "]")
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    var popoverTriggerList = [].slice.call(
        document.querySelectorAll("[" + app.bootstrap.popover.attr + "]")
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });
};

/* 07. Handle Scroll to Top Button
------------------------------------------------ */
var handleScrollToTopButton = function () {
    "use strict";

    var elmTriggerList = [].slice.call(
        document.querySelectorAll("[" + app.scrollToTopBtn.toggleAttr + "]")
    );

    document.onscroll = function () {
        var doc = document.documentElement;
        var totalScroll =
            (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        var elmList = elmTriggerList.map(function (elm) {
            if (totalScroll >= app.scrollToTopBtn.heightShow) {
                if (!elm.classList.contains(app.scrollToTopBtn.showClass)) {
                    elm.classList.add(app.scrollToTopBtn.showClass);
                }
            } else {
                elm.classList.remove(app.scrollToTopBtn.showClass);
            }
        });

        var elm = document.querySelectorAll(app.id)[0];

        if (totalScroll > 0) {
            elm.classList.add(app.header.hasScrollClass);
        } else {
            elm.classList.remove(app.header.hasScrollClass);
        }
    };

    var elmList = elmTriggerList.map(function (elm) {
        elm.onclick = function (e) {
            e.preventDefault();

            window.scrollTo({ top: 0, behavior: "smooth" });
        };
    });
};

/* 08. Handle hexToRgba
------------------------------------------------ */
var hexToRgba = function (hex, transparent = 1) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
            "rgba(" +
            [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
            "," +
            transparent +
            ")"
        );
    }
    throw new Error("Bad Hex");
};

/* 09. Handle Scroll To
------------------------------------------------ */
var handleScrollTo = function () {
    var elmTriggerList = [].slice.call(
        document.querySelectorAll("[" + app.scrollTo.attr + "]")
    );
    var elmList = elmTriggerList.map(function (elm) {
        elm.onclick = function (e) {
            e.preventDefault();

            var targetAttr = elm.getAttribute(app.scrollTo.target)
                ? this.getAttribute(app.scrollTo.target)
                : this.getAttribute(app.scrollTo.linkTarget);
            var targetElm = document.querySelectorAll(targetAttr)[0];
            var targetHeader = document.querySelectorAll(app.header.id)[0];
            var targetHeight = targetHeader.offsetHeight;
            if (targetElm) {
                var targetTop = targetElm.offsetTop - targetHeight - 24;
                window.scrollTo({ top: targetTop, behavior: "smooth" });
            }
        };
    });
};

/* 10. Handle Toggle Class
------------------------------------------------ */
var handleToggleClass = function () {
    var elmList = [].slice.call(
        document.querySelectorAll("[" + app.toggleClass.toggleAttr + "]")
    );

    elmList.map(function (elm) {
        elm.onclick = function (e) {
            e.preventDefault();

            var targetToggleClass = this.getAttribute(app.toggleClass.toggleAttr);
            var targetDismissClass = this.getAttribute(app.dismissClass.toggleAttr);
            var targetToggleElm = document.querySelector(
                this.getAttribute(app.toggleClass.targetAttr)
            );

            if (!targetDismissClass) {
                if (targetToggleElm.classList.contains(targetToggleClass)) {
                    targetToggleElm.classList.remove(targetToggleClass);
                } else {
                    targetToggleElm.classList.add(targetToggleClass);
                }
            } else {
                if (
                    !targetToggleElm.classList.contains(targetToggleClass) &&
                    !targetToggleElm.classList.contains(targetDismissClass)
                ) {
                    if (targetToggleElm.classList.contains(targetToggleClass)) {
                        targetToggleElm.classList.remove(targetToggleClass);
                    } else {
                        targetToggleElm.classList.add(targetToggleClass);
                    }
                } else {
                    if (targetToggleElm.classList.contains(targetToggleClass)) {
                        targetToggleElm.classList.remove(targetToggleClass);
                    } else {
                        targetToggleElm.classList.add(targetToggleClass);
                    }
                    if (targetToggleElm.classList.contains(targetDismissClass)) {
                        targetToggleElm.classList.remove(targetDismissClass);
                    } else {
                        targetToggleElm.classList.add(targetDismissClass);
                    }
                }
            }
        };
    });
};

/* 11. Handle Theme Panel
------------------------------------------------ */
var handleThemePanel = function () {
    "use strict";

    var themePanel = document.querySelector("." + app.themePanel.class);

    if (!themePanel) {
        return;
    }

    var themeSaveUrl = themePanel.getAttribute("data-save-url");
    var csrfMeta = document.querySelector('meta[name="csrf-token"]');
    var csrfToken = csrfMeta ? csrfMeta.getAttribute("content") : "";

    var applyThemeSelection = function (targetTheme, dispatchReload) {
        if (!targetTheme) {
            return;
        }

        for (var x = document.body.classList.length - 1; x >= 0; x--) {
            var targetClass = document.body.classList[x];
            if (targetClass.search("theme-") > -1) {
                document.body.classList.remove(targetClass);
            }
        }

        document.body.classList.add(targetTheme);

        [].slice.call(
            document.querySelectorAll(
                "." + app.themePanel.class + " [" + app.themePanel.theme.toggleAttr + "]"
            )
        ).forEach(function (targetElm) {
            var listItem = targetElm.closest("." + app.themePanel.themeListItemCLass);
            if (listItem) {
                listItem.classList.toggle(
                    app.themePanel.theme.activeClass,
                    targetElm.getAttribute(app.themePanel.theme.classAttr) == targetTheme
                );
            }
        });

        app.color.theme = getComputedStyle(document.body)
            .getPropertyValue("--bs-theme")
            .trim();
        app.color.themeRgb = getComputedStyle(document.body)
            .getPropertyValue("--bs-theme-rgb")
            .trim();

        if (dispatchReload) {
            document.dispatchEvent(new Event("theme-reload"));
        }
    };

    var applyThemeCoverSelection = function (targetTheme) {
        if (!targetTheme) {
            return;
        }

        var htmlElm = document.querySelector("html");
        for (var x = document.documentElement.classList.length - 1; x >= 0; x--) {
            var targetClass = document.documentElement.classList[x];
            if (targetClass.search("bg-cover-") > -1) {
                htmlElm.classList.remove(targetClass);
            }
        }

        htmlElm.classList.add(targetTheme);

        [].slice.call(
            document.querySelectorAll(
                "." + app.themePanel.class + " [" + app.themePanel.themeCover.toggleAttr + "]"
            )
        ).forEach(function (targetElm) {
            var listItem = targetElm.closest("." + app.themePanel.themeCoverItemClass);
            if (listItem) {
                listItem.classList.toggle(
                    app.themePanel.themeCover.activeClass,
                    targetElm.getAttribute(app.themePanel.themeCover.classAttr) == targetTheme
                );
            }
        });
    };

    var persistThemeSelection = function (payload) {
        if (!themeSaveUrl || !payload || !window.fetch) {
            return Promise.resolve();
        }

        var requestBody = new URLSearchParams();
        requestBody.append("csrf_token", csrfToken);

        Object.keys(payload).forEach(function (key) {
            if (payload[key]) {
                requestBody.append(key, payload[key]);
            }
        });

        return fetch(themeSaveUrl, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": csrfToken,
            },
            body: requestBody.toString(),
        }).catch(function () {
            return null;
        });
    };

    // 12.1 Theme Panel - Toggle / Dismiss
    var elmList = [].slice.call(
        document.querySelectorAll("[" + app.themePanel.toggleAttr + "]")
    );

    elmList.map(function (elm) {
        elm.onclick = function (e) {
            e.preventDefault();

            var targetContainer = document.querySelector("." + app.themePanel.class);
            var targetExpand = false;

            if (targetContainer.classList.contains(app.themePanel.activeClass)) {
                targetContainer.classList.remove(app.themePanel.activeClass);
            } else {
                targetContainer.classList.add(app.themePanel.activeClass);
                targetExpand = true;
            }
            if (Cookies) {
                Cookies.set(app.themePanel.cookieName, targetExpand);
            }
        };
    });

    // 12.2 Theme Panel - Page Load Cookies
    if (Cookies) {
        var themePanelExpand = Cookies.get(app.themePanel.cookieName);

        if (themePanelExpand == "true" || typeof themePanelExpand == "undefined") {
            var elm = document.querySelector("[" + app.themePanel.toggleAttr + "]");
            if (elm) {
                elm.click();
            }
        }
    }

    // 12.3 Theme Panel - Theme Selector
    var elmList = [].slice.call(
        document.querySelectorAll(
            "." + app.themePanel.class + " [" + app.themePanel.theme.toggleAttr + "]"
        )
    );
    elmList.map(function (elm) {
        elm.onclick = function (e) {
            var targetTheme = this.getAttribute(app.themePanel.theme.classAttr);
            applyThemeSelection(targetTheme, true);

            if (Cookies) {
                Cookies.set(app.themePanel.theme.cookieName, targetTheme);
            }

            if (!e || e.isTrusted !== false) {
                persistThemeSelection({ theme: targetTheme });
            }
        };
    });

    if (Cookies) {
        var savedThemeClass = Cookies.get(app.themePanel.theme.cookieName);
        if (savedThemeClass) {
            applyThemeSelection(savedThemeClass, true);
        }
    }

    // 12.4 Theme Panel - Background Selector
    var elmList = [].slice.call(
        document.querySelectorAll(
            "." +
            app.themePanel.class +
            " [" +
            app.themePanel.themeCover.toggleAttr +
            "]"
        )
    );
    elmList.map(function (elm) {
        elm.onclick = function (e) {
            e.preventDefault();

            var targetTheme = this.getAttribute(app.themePanel.themeCover.classAttr);
            applyThemeCoverSelection(targetTheme);
            if (Cookies) {
                Cookies.set(app.themePanel.themeCover.cookieName, targetTheme);
            }

            if (!e || e.isTrusted !== false) {
                persistThemeSelection({ cover: targetTheme });
            }
        };
    });

    if (Cookies) {
        var savedCoverClass = Cookies.get(app.themePanel.themeCover.cookieName);
        if (savedCoverClass) {
            applyThemeCoverSelection(savedCoverClass);
        }
    }
};

/* 12. Handle Action Button Normalization
------------------------------------------------ */
var handleActionButtonNormalization = function () {
    "use strict";

    var candidateSelector = ".app-content .btn, .app-content a.btn";
    var compactActionContextSelector = [
        "td",
        ".table-action-group",
        ".action-button-group",
        ".action-button-row",
        ".admin-action-cluster",
        ".card-footer",
        ".trace-detail-card"
    ].join(", ");
    var ignoredContainerSelector = [
        ".nav",
        ".nav-pills",
        ".nav-tabs",
        ".pagination",
        ".breadcrumb",
        ".dropdown-menu",
        ".toast-header",
        ".note-toolbar"
    ].join(", ");
    var purposeMap = [
        {
            type: "danger",
            icon: "fa-trash",
            pattern: /(delete|remove|revoke|purge)/i
        },
        {
            type: "warning",
            icon: "fa-ban",
            pattern: /(disable|deactivate|ban|deny|suspend|block)/i
        },
        {
            type: "warning",
            icon: "fa-lock",
            pattern: /(lock)/i
        },
        {
            type: "success",
            icon: "fa-toggle-on",
            pattern: /(enable|activate|approve|start|resume|unban)/i
        },
        {
            type: "success",
            icon: "fa-unlock",
            pattern: /(unlock|restore)/i
        },
        {
            type: "success",
            icon: "fa-star",
            pattern: /(default|make default|set default)/i
        },
        {
            type: "success",
            icon: "fa-save",
            pattern: /(save|submit|apply)/i
        },
        {
            type: "success",
            icon: "fa-plus",
            pattern: /(add|create|new\b)/i
        },
        {
            type: "success",
            icon: "fa-upload",
            pattern: /(upload)/i
        },
        {
            type: "success",
            icon: "fa-file-import",
            pattern: /(import)/i
        },
        {
            type: "info",
            icon: "fa-pen",
            pattern: /(edit|rename|modify)/i
        },
        {
            type: "info",
            icon: "fa-copy",
            pattern: /(copy(?: code| credentials| username)?)/i
        },
        {
            type: "info",
            icon: "fa-tv",
            pattern: /(trakt)/i
        },
        {
            type: "info",
            icon: "fa-cog",
            pattern: /(settings|configure|config|setup)/i
        },
        {
            type: "info",
            icon: "fa-bars",
            pattern: /(pages?)/i
        },
        {
            type: "info",
            icon: "fa-map-marker-alt",
            pattern: /(trace)/i
        },
        {
            type: "info",
            icon: "fa-sync-alt",
            pattern: /(check update|refresh|revalidate|sync|reload|retry)/i
        },
        {
            type: "info",
            icon: "fa-eye",
            pattern: /(view|preview|show)/i
        },
        {
            type: "info",
            icon: "fa-external-link-alt",
            pattern: /(open|launch|visit)/i
        },
        {
            type: "info",
            icon: "fa-mobile-alt",
            pattern: /(devices?)/i
        },
        {
            type: "warning",
            icon: "fa-undo",
            pattern: /(reset|rollback|clear(?: log| cache)?)/i
        },
        {
            type: "info",
            icon: "fa-check-circle",
            pattern: /(verify|validate|test)/i
        },
        {
            type: "danger",
            icon: "fa-trash",
            pattern: /(delete|remove|revoke|purge)/i
        }
    ];
    var removableButtonClasses = [
        "btn-default",
        "btn-danger",
        "btn-warning",
        "btn-success",
        "btn-info",
        "btn-primary",
        "btn-secondary",
        "btn-dark",
        "btn-light",
        "btn-outline-danger",
        "btn-outline-warning",
        "btn-outline-success",
        "btn-outline-info",
        "btn-outline-primary",
        "btn-outline-default",
        "btn-outline-secondary",
        "btn-outline-dark",
        "btn-outline-light"
    ];
    var neutralLabelPattern = /^(close|cancel|dismiss|back)$/i;
    var utilityLabelPattern = /(generate|random|browse|calendar)/i;

    var normalizeLabel = function (value) {
        return (value || "").replace(/\s+/g, " ").trim();
    };

    var resolveButtonLabel = function (button) {
        var textLabel = normalizeLabel(button.textContent || "");

        if (textLabel) {
            return {
                value: textLabel,
                source: "text"
            };
        }

        var attributeLabel = normalizeLabel(
            button.getAttribute("data-action-label") ||
            button.getAttribute("aria-label") ||
            button.getAttribute("title") ||
            button.getAttribute("value") ||
            ""
        );

        return {
            value: attributeLabel,
            source: attributeLabel ? "attribute" : null
        };
    };

    var resolveButtonConfig = function (element, label) {
        for (var index = 0; index < purposeMap.length; index++) {
            if (purposeMap[index].pattern.test(label)) {
                return purposeMap[index];
            }
        }

        if (element.classList.contains("btn-outline-danger") || element.classList.contains("btn-danger")) {
            return {
                type: "danger",
                icon: "fa-trash"
            };
        }

        if (element.classList.contains("btn-outline-warning") || element.classList.contains("btn-warning")) {
            return {
                type: "warning",
                icon: "fa-ban"
            };
        }

        if (element.classList.contains("btn-outline-success") || element.classList.contains("btn-success")) {
            return {
                type: "success",
                icon: "fa-check"
            };
        }

        if (element.classList.contains("btn-outline-info") || element.classList.contains("btn-info") || element.classList.contains("btn-outline-primary") || element.classList.contains("btn-primary")) {
            return {
                type: "info",
                icon: "fa-circle-info"
            };
        }

        return null;
    };

    var shouldSkipButton = function (button, label) {
        if (!button || button.dataset.actionButtonNormalized === "true") {
            return true;
        }

        if (button.getAttribute("data-no-action-button-normalize") === "true") {
            return true;
        }

        if (button.hasAttribute("data-bs-dismiss") || button.classList.contains("btn-close") || button.classList.contains("dropdown-toggle") || button.classList.contains("accordion-button") || button.classList.contains("page-link") || button.classList.contains("fileinput-button")) {
            return true;
        }

        if (button.closest(ignoredContainerSelector)) {
            return true;
        }

        if (neutralLabelPattern.test(label)) {
            return true;
        }

        if (button.closest(".input-group") && utilityLabelPattern.test(label)) {
            return true;
        }

        if (button.id === "togglePasswordBtn" && button.closest(".input-group")) {
            return true;
        }

        return false;
    };

    var isCompactActionContext = function (button) {
        return !!(
            button.closest(compactActionContextSelector)
        );
    };

    var persistAccessibleActionLabel = function (button, label) {
        var normalizedLabel = normalizeLabel(label);

        if (!normalizedLabel) {
            return;
        }

        button.setAttribute("data-action-label", normalizedLabel);
        button.setAttribute("aria-label", normalizedLabel);
        button.setAttribute("title", normalizedLabel);
    };

    var stripVisibleButtonText = function (button, icon) {
        [].slice.call(button.childNodes || []).forEach(function (node) {
            if (node === icon) {
                return;
            }

            if (node.nodeType === 3) {
                if (normalizeLabel(node.textContent || "")) {
                    button.removeChild(node);
                }
                return;
            }

            if (node.nodeType !== 1) {
                return;
            }

            if (node.classList && node.classList.contains("btn-action-text")) {
                node.remove();
                return;
            }

            if ((node.tagName === "SPAN" || node.tagName === "SMALL" || node.tagName === "STRONG") && !node.querySelector("i")) {
                node.remove();
            }
        });
    };

    var ensureButtonIcon = function (button, semanticConfig, hasVisibleText) {
        var icon = button.querySelector("i");
        var createdIcon = false;

        if (!icon) {
            icon = document.createElement("i");
            icon.className = "fas " + semanticConfig.icon;
            button.insertBefore(icon, button.firstChild);
            createdIcon = true;
        }

        if (!/\bfas\b/.test(icon.className)) {
            icon.classList.add("fas");
        }

        if (createdIcon && !new RegExp("\\b" + semanticConfig.icon + "\\b").test(icon.className)) {
            icon.classList.add(semanticConfig.icon);
        }

        if (hasVisibleText) {
            icon.classList.remove("me-1");
            icon.classList.add("me-2");
        } else {
            icon.classList.remove("me-1", "me-2");
        }

        icon.classList.add("btn-action-icon", "btn-action-icon-" + semanticConfig.type);

        return icon;
    };

    var ensureButtonText = function (button, labelState, icon) {
        if (labelState.source === "text") {
            return;
        }

        var displayLabel = normalizeLabel(labelState.value);

        if (!displayLabel) {
            return;
        }

        var textNode = button.querySelector(".btn-action-text");

        if (!textNode) {
            textNode = document.createElement("span");
            textNode.className = "btn-action-text";
            if (icon && icon.nextSibling) {
                button.insertBefore(textNode, icon.nextSibling);
            } else {
                button.appendChild(textNode);
            }
        }

        textNode.textContent = displayLabel;
        icon.classList.remove("me-1");
        icon.classList.add("me-2");
    };

    var getActionGroupItems = function (group) {
        var items = [];

        [].slice.call(group.children || []).forEach(function (child) {
            if (!child || child.nodeType !== 1) {
                return;
            }

            if (child.matches(".btn, a.btn")) {
                items.push({
                    container: child,
                    button: child
                });
                return;
            }

            if (child.matches("form")) {
                var formButton = child.querySelector(".btn, a.btn");
                if (formButton) {
                    items.push({
                        container: child,
                        button: formButton
                    });
                }
            }
        });

        return items;
    };

    var equalizeActionGroupWidths = function (root) {
        var scope = root && root.querySelectorAll ? root : document;
        var groups = [];

        if (scope.matches && scope.matches(".action-button-group, .action-button-row, .admin-action-cluster")) {
            groups.push(scope);
        }

        groups = groups.concat([].slice.call(scope.querySelectorAll(".action-button-group, .action-button-row, .admin-action-cluster")));

        groups.forEach(function (group) {
            var items = getActionGroupItems(group);

            if (!items.length) {
                return;
            }

            items.forEach(function (item) {
                item.container.style.minWidth = "";
                item.container.style.width = "";
                item.button.style.minWidth = "";
                item.button.style.width = "";
            });

            var maxWidth = items.reduce(function (largestWidth, item) {
                return Math.max(largestWidth, Math.ceil(item.button.getBoundingClientRect().width));
            }, 0);

            if (!maxWidth) {
                return;
            }

            items.forEach(function (item) {
                if (item.container !== item.button) {
                    item.container.style.minWidth = maxWidth + "px";
                    item.button.style.width = "100%";
                } else {
                    item.button.style.minWidth = maxWidth + "px";
                }
            });
        });
    };

    var ensurePurposeIcon = function (button, buttonConfig, labelState, compactMode) {
        if (!buttonConfig) {
            return null;
        }

        var hasVisibleText = !compactMode && labelState.source === "text";
        var icon = ensureButtonIcon(button, buttonConfig, hasVisibleText);

        if (compactMode) {
            persistAccessibleActionLabel(button, labelState.value);
            stripVisibleButtonText(button, icon);
            return icon;
        }

        if (!hasVisibleText) {
            ensureButtonText(button, labelState, icon);
        }

        return icon;
    };

    var normalizeButton = function (button) {
        var labelState = resolveButtonLabel(button);
        var buttonConfig = resolveButtonConfig(button, labelState.value);
        var compactMode = isCompactActionContext(button);

        if (shouldSkipButton(button, labelState.value)) {
            return;
        }

        if (!buttonConfig) {
            return;
        }

        ensurePurposeIcon(button, buttonConfig, labelState, compactMode);

        if (!compactMode) {
            button.dataset.actionButtonNormalized = "true";
            return;
        }

        removableButtonClasses.forEach(function (className) {
            button.classList.remove(className);
        });

        button.classList.add("btn-outline-theme", "btn-action-theme", "btn-action-" + buttonConfig.type, "table-action-button");
        var icon = button.querySelector("i");
        var actionGroup = button.closest(".btn-group, .btn-group-vertical");
        var actionRow = button.closest(".card-footer");

        if (actionGroup) {
            actionGroup.classList.add("action-button-group");
        }

        if (actionRow) {
            actionRow.classList.add("action-button-row");
        }

        persistAccessibleActionLabel(button, labelState.value);

        if (icon) {
            icon.classList.remove("me-1", "me-2");
        }

        button.dataset.actionButtonNormalized = "true";
    };

    var scan = function (root) {
        var scope = root && root.querySelectorAll ? root : document;
        [].slice.call(scope.querySelectorAll(candidateSelector)).forEach(normalizeButton);
        equalizeActionGroupWidths(scope);
    };

    scan(document);

    window.addEventListener("resize", function () {
        equalizeActionGroupWidths(document);
    });

    if (!document.body || typeof MutationObserver === "undefined") {
        return;
    }

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            [].slice.call(mutation.addedNodes || []).forEach(function (node) {
                if (node.nodeType !== 1) {
                    return;
                }

                if (node.matches && node.matches(candidateSelector)) {
                    normalizeButton(node);
                }

                scan(node);
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};

/* 13. Handle File Form Enhancements
------------------------------------------------ */
var handleFileFormEnhancements = function () {
    "use strict";

    var enhancedFormFlag = "data-file-form-enhanced";
    var fileNameClass = "file-upload-selection";

    var updateSelectionText = function (fileInput) {
        var form = fileInput.closest("form");
        if (!form) {
            return;
        }

        var selectionNode = form.querySelector("." + fileNameClass + '[data-input-id="' + (fileInput.id || "") + '"]');
        var fileName = "";

        if (fileInput.files && fileInput.files.length > 0) {
            fileName = fileInput.files[0].name;
        }

        if (!selectionNode) {
            selectionNode = document.createElement("div");
            selectionNode.className = fileNameClass + " small text-muted mt-2";
            selectionNode.setAttribute("data-input-id", fileInput.id || "");
            fileInput.parentNode.appendChild(selectionNode);
        }

        selectionNode.textContent = fileName ? ("Selected: " + fileName) : "";
    };

    var bindForm = function (form) {
        if (!form || form.getAttribute(enhancedFormFlag) === "true") {
            return;
        }

        if (form.id === "fileupload") {
            return;
        }

        var fileInputs = [].slice.call(
            form.querySelectorAll('input[type="file"]:not([multiple])')
        );

        if (!fileInputs.length) {
            return;
        }

        form.setAttribute(enhancedFormFlag, "true");

        fileInputs.forEach(function (fileInput, idx) {
            if (!fileInput.id) {
                fileInput.id = "file-upload-input-" + Date.now() + "-" + idx;
            }

            fileInput.addEventListener("change", function () {
                updateSelectionText(fileInput);
            });
        });

        form.addEventListener("submit", function () {
            var hasSelection = fileInputs.some(function (fileInput) {
                return fileInput.files && fileInput.files.length > 0;
            });

            if (!hasSelection) {
                return;
            }

            var submitButton =
                form.querySelector('button[type="submit"]') ||
                form.querySelector('input[type="submit"]');

            if (!submitButton || submitButton.dataset.fileUploadBusy === "true") {
                return;
            }

            submitButton.dataset.fileUploadBusy = "true";

            if (submitButton.tagName.toLowerCase() === "button") {
                submitButton.dataset.originalHtml = submitButton.innerHTML;
                submitButton.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Uploading...';
            } else {
                submitButton.dataset.originalValue = submitButton.value;
                submitButton.value = "Uploading...";
            }

            submitButton.disabled = true;
        });
    };

    var bindAll = function (root) {
        var scope = root && root.querySelectorAll ? root : document;
        var forms = [].slice.call(
            scope.querySelectorAll('form[enctype="multipart/form-data"]')
        );

        forms.forEach(bindForm);
    };

    bindAll(document);

    if (!document.body || typeof MutationObserver === "undefined") {
        return;
    }

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            [].slice.call(mutation.addedNodes || []).forEach(function (node) {
                if (!node || node.nodeType !== 1) {
                    return;
                }

                if (
                    node.matches &&
                    node.matches('form[enctype="multipart/form-data"]')
                ) {
                    bindForm(node);
                }

                bindAll(node);
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};

/* 14. Handle Datepicker Quick Actions
------------------------------------------------ */
var handleDatepickerQuickActions = function () {
    if (typeof window.jQuery === "undefined") {
        return;
    }

    if (window.__cockpitDatepickerQuickActionsBound) {
        return;
    }

    window.__cockpitDatepickerQuickActionsBound = true;

    var $ = window.jQuery;
    var quickActions = [
        { label: "1d", amount: 1, unit: "d" },
        { label: "1mo", amount: 1, unit: "m" },
        { label: "6mo", amount: 6, unit: "m" },
        { label: "1yr", amount: 1, unit: "y" }
    ];
    var quickTargetCounter = 0;

    var applyDateOffset = function (amount, unit) {
        var targetDate = new Date();

        if (unit === "y") {
            targetDate.setFullYear(targetDate.getFullYear() + amount);
        } else if (unit === "m") {
            targetDate.setMonth(targetDate.getMonth() + amount);
        } else {
            targetDate.setDate(targetDate.getDate() + amount);
        }

        return targetDate;
    };

    var resolveDatepickerTarget = function (targetId) {
        var $target = targetId ? $("#" + targetId) : $();

        if (!$target.length) {
            return $();
        }

        if ($target.data("datepicker")) {
            return $target;
        }

        var $owner = $target.closest(".date, .input-group.date, .input-daterange");
        if ($owner.length && $owner.data("datepicker")) {
            return $owner;
        }

        return $target;
    };

    var handleQuickActionSelect = function (event) {
        event.preventDefault();
        event.stopPropagation();

        var $button = $(event.currentTarget);
        var amount = parseInt($button.attr("data-amount"), 10);
        var unit = $button.attr("data-unit");
        var selectedDate = applyDateOffset(amount, unit);
        var $actions = $button.closest(".datepicker-quick-actions");
        var targetId = $actions.attr("data-target-id") || "";
        var $target = resolveDatepickerTarget(targetId);

        if (!$target.length || !$.fn || !$.fn.datepicker) {
            return;
        }

        $target.datepicker("setDate", selectedDate);
        $target.trigger("change");
        $target.datepicker("hide");
    };

    var isExpiryField = function ($input) {
        var hintText = [
            $input.attr("id") || "",
            $input.attr("name") || "",
            $input.attr("placeholder") || "",
            $input.attr("aria-label") || "",
            $input.attr("data-quick-date-ranges") || ""
        ].join(" ");

        if (String($input.attr("data-quick-date-ranges") || "").toLowerCase() === "off") {
            return false;
        }

        if (String($input.attr("data-quick-date-ranges") || "").toLowerCase() === "on") {
            return true;
        }

        return /expir|expiry|expire/i.test(hintText);
    };

    var ensureInputId = function ($input) {
        var inputId = $input.attr("id");

        if (!inputId) {
            quickTargetCounter += 1;
            inputId = "quick-date-target-" + quickTargetCounter;
            $input.attr("id", inputId);
        }

        return inputId;
    };

    var installQuickActions = function ($input) {
        if (!$input || !$input.length || !isExpiryField($input)) {
            return;
        }

        if (!$.fn || !$.fn.datepicker) {
            return;
        }

        var datepickerInstance = $input.data("datepicker");
        if (!datepickerInstance || !datepickerInstance.picker) {
            return;
        }

        var $picker = datepickerInstance.picker;

        if (!$picker || !$picker.length || !$input.length) {
            return;
        }

        var inputId = ensureInputId($input);

        var $existing = $picker.find(".datepicker-quick-actions");
        if ($existing.length) {
            $existing.attr("data-target-id", inputId);
            return;
        }

        var actionButtons = quickActions
            .map(function (action) {
                return '<button type="button" class="btn btn-outline-theme btn-xs datepicker-quick-btn" data-amount="' +
                    action.amount +
                    '" data-unit="' +
                    action.unit +
                    '">' +
                    action.label +
                    "</button>";
            })
            .join("");

        var quickActionsHtml =
            '<div class="datepicker-quick-actions" data-target-id="' +
            inputId +
            '">' +
            '<span class="datepicker-quick-label">Quick expiry</span>' +
            '<div class="datepicker-quick-buttons">' +
            actionButtons +
            "</div></div>";

        var $daysView = $picker.find(".datepicker-days").first();
        if ($daysView.length) {
            $daysView.append(quickActionsHtml);
        } else {
            $picker.append(quickActionsHtml);
        }

        $picker
            .off("mousedown.datepickerQuickActions", ".datepicker-quick-btn")
            .on("mousedown.datepickerQuickActions", ".datepicker-quick-btn", handleQuickActionSelect);
    };

    $(document)
        .off("click.datepickerQuickActions")
        .on("click.datepickerQuickActions", ".datepicker-quick-btn", function (event) {
            handleQuickActionSelect(event);
        });

    var maybeInstallFromElement = function (element) {
        var $input = $(element);
        window.setTimeout(function () {
            installQuickActions($input);
        }, 0);
    };

    $(document)
        .off("show.datepickerQuickActions")
        .on("show.datepickerQuickActions", "input, .form-control", function () {
            maybeInstallFromElement(this);
        });

    $(document)
        .off("focusin.datepickerQuickActions")
        .on("focusin.datepickerQuickActions", "input, .form-control", function () {
            maybeInstallFromElement(this);
        });
};

var syncBootstrapTableMobileLayout = function () {
    "use strict";

    if (typeof window.jQuery === "undefined") {
        return;
    }

    var $ = window.jQuery;

    if (!$.fn || !$.fn.bootstrapTable) {
        return;
    }

    var isCompactViewport = window.innerWidth <= 768;
    if (!isCompactViewport) {
        return;
    }

    $('[data-toggle="table"][data-mobile-responsive="true"]').each(function () {
        var $table = $(this);
        var tableApi = $table.data("bootstrap.table");

        if (tableApi && typeof $table.bootstrapTable === "function") {
            try {
                $table.bootstrapTable("resetView");
            } catch (error) {
                // Ignore table instances that are still initializing.
            }
        }

        var $body = $table
            .closest(".bootstrap-table")
            .find(".fixed-table-body")
            .first();

        if ($body.length) {
            $body.scrollTop(0);
        }
    });
};

var queueBootstrapTableMobileLayoutSync = function () {
    "use strict";

    window.requestAnimationFrame(function () {
        syncBootstrapTableMobileLayout();
        window.setTimeout(syncBootstrapTableMobileLayout, 120);
    });
};

var isElementVisible = function (element) {
    "use strict";

    if (!element || !element.isConnected) {
        return false;
    }

    var hiddenPane = element.closest(".tab-pane");
    if (
        hiddenPane &&
        !hiddenPane.classList.contains("active") &&
        !hiddenPane.classList.contains("show")
    ) {
        return false;
    }

    var computed = window.getComputedStyle(element);
    if (computed.display === "none" || computed.visibility === "hidden") {
        return false;
    }

    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
};

var primeBootstrapTableHeights = function () {
    "use strict";

    if (typeof window.jQuery === "undefined") {
        return;
    }

    var $ = window.jQuery;
    if (!$.fn || !$.fn.bootstrapTable) {
        return;
    }

    var clamp = function (value, min, max) {
        return Math.min(Math.max(value, min), max);
    };
    
    var getFormPanelHeight = function (panel) {
        var formElement = panel.querySelector("form");
        if (!formElement) {
            return 0;
        }

        var formContainer = formElement.closest(".card-body");
        var measuredElement =
            formContainer && panel.contains(formContainer) ? formContainer : formElement;

        return Math.round(measuredElement.getBoundingClientRect().height);
    };

    $('[data-toggle="table"]').each(function () {
        if (!isElementVisible(this)) {
            return;
        }

        var $table = $(this);
        if ((String($table.attr("data-search") || "")).toLowerCase() === "true") {
            return;
        }

        var currentHeight = parseInt($table.attr("data-height"), 10);

        if (Number.isNaN(currentHeight) || currentHeight !== 460) {
            return;
        }

        var tableColumn = this.closest('[class*="col-"]');
        if (!tableColumn) {
            return;
        }

        var parentRow = tableColumn.closest(".row");
        if (!parentRow) {
            return;
        }

        var siblingColumns = [].slice
            .call(parentRow.children)
            .filter(function (column) {
                return column !== tableColumn;
            });

        var formPanel = siblingColumns.find(function (column) {
            return !!column.querySelector("form");
        });

        if (!formPanel) {
            return;
        }

        var formHeight = getFormPanelHeight(formPanel);
        if (formHeight <= 0) {
            return;
        }

        $table.attr("data-height", clamp(formHeight, 260, 620));
        $table.attr("data-auto-height", "true");
    });
};

var syncClientListSearch = function () {
    "use strict";

    if (typeof window.jQuery === "undefined") {
        return;
    }

    var $ = window.jQuery;
    if (!$.fn || !$.fn.bootstrapTable) {
        return;
    }

    $('[data-toggle="table"]').each(function () {
        if (!isElementVisible(this)) {
            return;
        }

        var $table = $(this);
        var hasSearch = (String($table.attr("data-search") || "")).toLowerCase() === "true";

        if (!hasSearch) {
            return;
        }

        if ($table.closest(".admin-table-shell").length) {
            return;
        }

        if ($table.attr("data-pagination") !== "true") {
            $table.attr("data-pagination", "true");
        }

        if (!$table.attr("data-page-size")) {
            $table.attr("data-page-size", "25");
        }

        var desiredPageSize = parseInt($table.attr("data-page-size"), 10) || 25;

        if ($table.data("bootstrap.table") && typeof $table.bootstrapTable === "function") {
            try {
                var $bootstrapTable = $table.closest(".bootstrap-table");
                var searchInput = $bootstrapTable
                    .find('.fixed-table-toolbar .search input[type="search"], .fixed-table-toolbar .search input')
                    .first();

                if (searchInput.length && searchInput.is(":focus")) {
                    return;
                }

                var currentOptions = $table.bootstrapTable("getOptions") || {};
                var currentPageSize = parseInt(currentOptions.pageSize, 10) || 0;
                var needsRefresh =
                    currentOptions.search !== true ||
                    currentOptions.pagination !== true ||
                    currentPageSize !== desiredPageSize;

                if (needsRefresh) {
                    $table.bootstrapTable("refreshOptions", {
                        search: true,
                        pagination: true,
                        pageSize: desiredPageSize
                    });
                }

                var $toolbar = $bootstrapTable.find(".fixed-table-toolbar").first();
                if ($toolbar.length) {
                    $toolbar.addClass("cockpit-search-toolbar");

                    var $heading = $();
                    var $tableColumn = $bootstrapTable.closest('[class*="col-"]');

                    if (!$tableColumn.length) {
                        $tableColumn = $table.closest('[class*="col-"]');
                    }

                    if ($tableColumn.length) {
                        $heading = $tableColumn.children(".card-title, h5, h4, .card-header").first();

                        if (!$heading.length) {
                            $heading = $tableColumn.find(".card-title, h5, h4, .card-header").first();
                        }
                    }

                    if (!$heading.length) {
                        $heading = $bootstrapTable.prevAll(".card-title, h5, h4, .card-header").first();
                    }

                    if (!$heading.length) {
                        $heading = $table.prevAll(".card-title, h5, h4, .card-header").first();
                    }

                    if ($heading.length) {
                        var headingHtml = $heading.html();
                        var $title = $toolbar.children(".cockpit-search-title").first();

                        if (!$title.length) {
                            $title = $('<div class="cockpit-search-title"></div>');
                            $toolbar.prepend($title);
                        }

                        if ($title.html() !== headingHtml) {
                            $title.html(headingHtml);
                        }

                        $heading.addClass("cockpit-search-title-source");
                    }
                }
            } catch (error) {
                // Ignore transient states while table initializes.
            }
        }
    });
};

var queueClientListSearchSync = function () {
    "use strict";

    if (queueClientListSearchSync._frame) {
        window.cancelAnimationFrame(queueClientListSearchSync._frame);
    }

    queueClientListSearchSync._frame = window.requestAnimationFrame(function () {
        syncClientListSearch();
    });
};

var syncBootstrapTableHeights = function () {
    "use strict";

    if (typeof window.jQuery === "undefined") {
        return;
    }

    var $ = window.jQuery;

    if (!$.fn || !$.fn.bootstrapTable) {
        return;
    }

    var clamp = function (value, min, max) {
        return Math.min(Math.max(value, min), max);
    };
    
    var getFormPanelHeight = function (panel) {
        var formElement = panel.querySelector("form");
        if (!formElement) {
            return 0;
        }

        var formContainer = formElement.closest(".card-body");
        var measuredElement =
            formContainer && panel.contains(formContainer) ? formContainer : formElement;

        return Math.round(measuredElement.getBoundingClientRect().height);
    };

    var getSplitFormHeight = function (tableElement) {
        var tableColumn = tableElement.closest('[class*="col-"]');
        if (!tableColumn) {
            return 0;
        }

        var parentRow = tableColumn.closest(".row");
        if (!parentRow) {
            return 0;
        }

        var siblingColumns = [].slice
            .call(parentRow.children)
            .filter(function (column) {
                return column !== tableColumn;
            });

        var formPanel = siblingColumns.find(function (column) {
            return !!column.querySelector("form");
        });

        if (!formPanel) {
            return 0;
        }

        return getFormPanelHeight(formPanel);
    };

    $('[data-toggle="table"]').each(function () {
        if (!isElementVisible(this)) {
            return;
        }

        var $table = $(this);
        if ((String($table.attr("data-search") || "")).toLowerCase() === "true") {
            return;
        }

        var table = this;
        var declaredHeight = $table.attr("data-height");
        var hasDeclaredHeight = typeof declaredHeight !== "undefined";
        var baseHeight = parseInt(declaredHeight, 10);

        // Auto-sync classic 460px tables and previously auto-synced tables.
        if (
            !hasDeclaredHeight &&
            !$table.attr("data-auto-height")
        ) {
            return;
        }

        if (
            hasDeclaredHeight &&
            (Number.isNaN(baseHeight) || (baseHeight !== 460 && !$table.attr("data-auto-height")))
        ) {
            return;
        }

        var formHeight = getSplitFormHeight(table);
        if (!formHeight) {
            return;
        }

        var targetHeight = clamp(formHeight, 260, 620);
        var currentHeight = parseInt($table.attr("data-height"), 10) || 0;

        if (Math.abs(targetHeight - currentHeight) < 8) {
            return;
        }

        $table.attr("data-height", targetHeight);
        $table.attr("data-auto-height", "true");

        if ($table.data("bootstrap.table") && typeof $table.bootstrapTable === "function") {
            try {
                var currentOptions = $table.bootstrapTable("getOptions") || {};
                var currentPluginHeight = parseInt(currentOptions.height, 10) || 0;

                if (currentPluginHeight > 0 && Math.abs(targetHeight - currentPluginHeight) < 8) {
                    return;
                }

                var nextOptions = { height: targetHeight };

                if (typeof currentOptions.search !== "undefined") {
                    nextOptions.search = currentOptions.search;
                }

                if (typeof currentOptions.pagination !== "undefined") {
                    nextOptions.pagination = currentOptions.pagination;
                }

                if (typeof currentOptions.pageSize !== "undefined") {
                    nextOptions.pageSize = currentOptions.pageSize;
                }

                $table.bootstrapTable("refreshOptions", nextOptions);
            } catch (error) {
                // Ignore races while table plugin is initializing.
            }
        }
    });
};

var queueBootstrapTableHeightSync = function () {
    "use strict";

    if (queueBootstrapTableHeightSync._frame) {
        window.cancelAnimationFrame(queueBootstrapTableHeightSync._frame);
    }

    queueBootstrapTableHeightSync._frame = window.requestAnimationFrame(function () {
        syncBootstrapTableHeights();
    });
};

var syncBootstrapTablePerfectScrollbars = function () {
    "use strict";

    var tableBodies = document.querySelectorAll(".bootstrap-table .fixed-table-body");
    var overflowStateAttr = "data-cockpit-overflow-state";

    for (var i = 0; i < tableBodies.length; i++) {
        var body = tableBodies[i];

        if (!isElementVisible(body)) {
            continue;
        }

        var bodyRect = body.getBoundingClientRect();

        if (!bodyRect.height || bodyRect.height <= 0) {
            continue;
        }

        if (!body.getAttribute("data-scrollbar")) {
            body.setAttribute("data-scrollbar", "true");
        }

        var bodyHeight = Math.round(bodyRect.height);
        if (bodyHeight <= 0) {
            continue;
        }

        body.setAttribute(app.scrollBar.heightAttr, bodyHeight + "px");

        var noRecordsRow = body.querySelector(".no-records-found");
        var hasOverflow = !noRecordsRow && body.scrollHeight > body.clientHeight + 1;
        var tableWrapper = body.closest(".bootstrap-table");
        var nextOverflowState = hasOverflow ? "overflow" : "no-overflow";
        var previousOverflowState = tableWrapper
            ? tableWrapper.getAttribute(overflowStateAttr)
            : null;
        var hasOverflowTransition =
            previousOverflowState !== null && previousOverflowState !== nextOverflowState;

        if (tableWrapper) {
            tableWrapper.classList.toggle("is-no-overflow", !hasOverflow);
            tableWrapper.setAttribute(overflowStateAttr, nextOverflowState);
        }

        if (!body.scrollbarInit) {
            generateScrollbar(body);
        } else if (body.perfectScrollbar && typeof body.perfectScrollbar.update === "function") {
            (function (scrollBody) {
                window.requestAnimationFrame(function () {
                    if (
                        scrollBody.perfectScrollbar &&
                        typeof scrollBody.perfectScrollbar.update === "function"
                    ) {
                        scrollBody.perfectScrollbar.update();
                    }
                });
            })(body);
        }

        if (hasOverflowTransition && tableWrapper) {
            var tableElement = tableWrapper.querySelector('table[data-toggle="table"]');
            if (tableElement) {
                alignBootstrapTableColumns(tableElement, true);
            }
        }
    }
};

var queueBootstrapTablePerfectScrollbarSync = function () {
    "use strict";

    if (queueBootstrapTablePerfectScrollbarSync._frame) {
        window.cancelAnimationFrame(queueBootstrapTablePerfectScrollbarSync._frame);
    }

    queueBootstrapTablePerfectScrollbarSync._frame = window.requestAnimationFrame(function () {
        syncBootstrapTablePerfectScrollbars();
    });
};

var alignBootstrapTableColumns = function (tableElement, forceReset) {
    "use strict";

    if (!tableElement || typeof window.jQuery === "undefined") {
        return;
    }

    var $ = window.jQuery;
    if (!$.fn || !$.fn.bootstrapTable) {
        return;
    }

    var $table = $(tableElement);
    if (!$table.data("bootstrap.table")) {
        return;
    }

    var $wrapper = $table.closest(".bootstrap-table");
    if (!$wrapper.length) {
        return;
    }

    var $headerTable = $wrapper.find(".fixed-table-header table").first();
    var $bodyTable = $wrapper.find(".fixed-table-body table").first();

    if (!$headerTable.length || !$bodyTable.length) {
        return;
    }

    var headerWidth = Math.round($headerTable.outerWidth() || 0);
    var bodyWidth = Math.round($bodyTable.outerWidth() || 0);
    var widthDelta = Math.abs(headerWidth - bodyWidth);

    if (!forceReset && widthDelta <= 1) {
        return;
    }

    var now = Date.now();
    var lastAlign = parseInt($table.attr("data-cockpit-last-align"), 10) || 0;
    var cooldown = forceReset ? 250 : 700;

    if (now - lastAlign < cooldown) {
        return;
    }

    $table.attr("data-cockpit-last-align", String(now));

    try {
        $table.bootstrapTable("resetView");
    } catch (error) {
        // Ignore transient plugin states while table redraw completes.
    }
};

/* 15. Application Controller
------------------------------------------------ */
var App = (function () {
    "use strict";

    return {
        //main function
        init: function () {
            this.initComponent();
            this.initSidebar();
            this.initAppLoad();
        },
        initAppLoad: function () {
            document.querySelector("body").classList.add(app.init.class);
        },
        initSidebar: function () {
            handleSidebarMenu();
            handleSidebarScrollMemory();
        },
        initComponent: function () {
            handleScrollbar();
            observeDynamicScrollbars();
            window.addEventListener("resize", refreshScrollbars);
            document.addEventListener("cockpit:content-updated", refreshScrollbars);
            window.addEventListener("resize", queueResponsiveDataTableScrollbarSync);
            window.addEventListener("orientationchange", queueResponsiveDataTableScrollbarSync);
            window.addEventListener("load", queueResponsiveDataTableScrollbarSync);
            document.addEventListener("cockpit:content-updated", queueResponsiveDataTableScrollbarSync);
            document.addEventListener("shown.bs.tab", queueResponsiveDataTableScrollbarSync);
            document.addEventListener("shown.bs.collapse", queueResponsiveDataTableScrollbarSync);
            primeBootstrapTableHeights();
            window.addEventListener("resize", queueBootstrapTableMobileLayoutSync);
            window.addEventListener("orientationchange", queueBootstrapTableMobileLayoutSync);
            window.addEventListener("load", queueBootstrapTableMobileLayoutSync);
            document.addEventListener("cockpit:content-updated", queueBootstrapTableMobileLayoutSync);
            window.addEventListener("resize", queueBootstrapTableHeightSync);
            window.addEventListener("orientationchange", queueBootstrapTableHeightSync);
            window.addEventListener("load", queueBootstrapTableHeightSync);
            document.addEventListener("cockpit:content-updated", queueBootstrapTableHeightSync);
            document.addEventListener("shown.bs.tab", queueBootstrapTableHeightSync);
            document.addEventListener("shown.bs.collapse", queueBootstrapTableHeightSync);
            window.addEventListener("resize", queueBootstrapTablePerfectScrollbarSync);
            window.addEventListener("orientationchange", queueBootstrapTablePerfectScrollbarSync);
            window.addEventListener("load", queueBootstrapTablePerfectScrollbarSync);
            document.addEventListener("cockpit:content-updated", queueBootstrapTablePerfectScrollbarSync);
            document.addEventListener("shown.bs.tab", queueBootstrapTablePerfectScrollbarSync);
            document.addEventListener("shown.bs.collapse", queueBootstrapTablePerfectScrollbarSync);
            window.addEventListener("load", queueClientListSearchSync);
            document.addEventListener("cockpit:content-updated", queueClientListSearchSync);
            document.addEventListener("shown.bs.tab", queueClientListSearchSync);
            document.addEventListener("shown.bs.collapse", queueClientListSearchSync);
            handleScrollToTopButton();
            handleScrollTo();
            handleCardAction();
            handelTooltipPopoverActivation();
            handleToggleClass();
            handleThemePanel();
            handleActionButtonNormalization();
            handleFileFormEnhancements();
            handleDatepickerQuickActions();
            queueResponsiveDataTableScrollbarSync();
            queueBootstrapTableMobileLayoutSync();
            queueBootstrapTableHeightSync();
            queueBootstrapTablePerfectScrollbarSync();
            queueClientListSearchSync();

            if (typeof window.jQuery !== "undefined") {
                var $ = window.jQuery;
                $(document)
                    .off("post-body.bs.table.cockpit")
                    .on("post-body.bs.table.cockpit", '[data-toggle="table"]', function () {
                        var tableElement = this;

                        if (window.__cockpitPostBodySyncTimer) {
                            window.clearTimeout(window.__cockpitPostBodySyncTimer);
                        }

                        window.__cockpitPostBodySyncTimer = window.setTimeout(function () {
                            queueBootstrapTablePerfectScrollbarSync();
                            alignBootstrapTableColumns(tableElement, false);
                        }, 180);
                    });
            }
        },
        scrollTop: function () {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    };
})();

/* 16. Initialise
------------------------------------------------ */
document.addEventListener("DOMContentLoaded", function () {
    App.init();
});
